import { useEffect, useState } from "react";
import { useApi } from "../../hooks/useApi";
import { AuthContext } from "./AuthContext";

export function AuthProvider({ children }: { children: JSX.Element }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [logged, setLogged] = useState<boolean>(false);
  const [applicationData, setApplicationData] = useState<WebtuorData | null>(
    null
  );

  const api = useApi();

  useEffect(() => {
    setLoading(true);
    (async () => {
      const token = localStorage.getItem("token");
      const storageData = JSON.parse(
        localStorage.getItem("webtour-data") || "null"
      );

      if (token && storageData) {
        setApplicationData(storageData);
        setUser(storageData.user);
        setLogged(true);
      }

      setLoading(false);
    })();
  }, []);

  const login = async (user: User) => {
    const data = await api.login(user);
    if (data.token) {
      setUser(user);
      const clientes = await api.clientes(data.token);
      data.clientes = clientes;

      // Fetch other data as needed...

      setApplicationData(data);
      setData(data);
      setLogged(true);

      // Store token and user data in localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("webtour-data", JSON.stringify({ ...data, user }));

      return data;
    }

    return null;
  };

  const signout = () => {
    setLogged(false);
    setUser(null);
    setApplicationData(null);
    // Clear localStorage on signout
    localStorage.removeItem("token");
    localStorage.removeItem("webtour-data");
  };

  const setData = (data: any) => {
    localStorage.setItem("webtour-data", JSON.stringify(data));
  };

  return (
    <AuthContext.Provider
      value={{ user, logged, login, signout, loading, applicationData }}
    >
      {children}
    </AuthContext.Provider>
  );
}
